import type { ReactStoryblokComponent } from "types/storyblok";
import RichtextAdapter from "../RichtextAdapter";
import contentStyles from "./Content.styles";
import type { ContentAdapterProps } from "./Content.d";

const ContentAdapter = ({ blok: { content }, sbEditable }: ReactStoryblokComponent<ContentAdapterProps>) => (
  <RichtextAdapter content={content} customStyles={contentStyles} sbEditable={sbEditable} />
);

export default ContentAdapter;
